import React from "react";
import { useTranslation } from "react-i18next";

function WordDocumentVariables() {
    const { t } = useTranslation();

    return (
        <div className="max-w-5xl mx-auto px-4 py-8">
            <div className="mb-8">
                <h1 className="text-3xl font-semibold mb-2">
                    {t("wordDocumentVariables.title")}
                </h1>
                <p className="text-gray-600 ">
                    {t("wordDocumentVariables.subtitle")}
                </p>

                <div className="mt-6">
                    <p className="text-gray-600 ">
                        {t("wordDocumentVariables.intro")}
                    </p>
                </div>
            </div>

            <div className="space-y-8">
                <section>
                    <h2 className="text-2xl font-semibold mb-4">
                        {t("wordDocumentVariables.whatYouCanDo.title")}
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="bg-blue-50  p-5 rounded-lg border border-blue-100 ">
                            <div className="flex items-center mb-3">
                                <span className="text-2xl mr-3">📄</span>
                                <h3 className="text-lg font-medium">
                                    {t(
                                        "wordDocumentVariables.whatYouCanDo.createOnce.title"
                                    )}
                                </h3>
                            </div>
                            <p>
                                {t(
                                    "wordDocumentVariables.whatYouCanDo.createOnce.description"
                                )}
                            </p>
                        </div>
                        <div className="bg-green-50  p-5 rounded-lg border border-green-100 ">
                            <div className="flex items-center mb-3">
                                <span className="text-2xl mr-3">⚡</span>
                                <h3 className="text-lg font-medium">
                                    {t(
                                        "wordDocumentVariables.whatYouCanDo.saveTime.title"
                                    )}
                                </h3>
                            </div>
                            <p>
                                {t(
                                    "wordDocumentVariables.whatYouCanDo.saveTime.description"
                                )}
                            </p>
                        </div>
                    </div>
                </section>

                <section>
                    <h2 className="text-2xl font-semibold mb-4">
                        {t("wordDocumentVariables.howItWorks.title")}
                    </h2>

                    <div className="relative pb-8">
                        <div className="absolute left-4 top-2 bottom-0 w-0.5 bg-gray-200 "></div>

                        <div className="relative flex items-start mb-8">
                            <div className="flex items-center justify-center w-8 h-8 rounded-full bg-blue-500 text-white font-bold text-sm absolute">
                                1
                            </div>
                            <div className="ml-12">
                                <h3 className="text-xl font-medium mb-3">
                                    {t(
                                        "wordDocumentVariables.howItWorks.step1.title"
                                    )}
                                </h3>
                                <div className="bg-white  shadow-sm rounded-lg border p-4 mb-3">
                                    <p className="mb-3">
                                        {t(
                                            "wordDocumentVariables.howItWorks.step1.description"
                                        )}
                                    </p>
                                    <div className="bg-yellow-50 dark:bg-yellow-900/30 border border-yellow-200 dark:border-yellow-800 p-3 rounded-md">
                                        <p className="font-medium mb-1">
                                            {t(
                                                "wordDocumentVariables.howItWorks.step1.example"
                                            )}
                                        </p>
                                        <p>
                                            {t(
                                                "wordDocumentVariables.howItWorks.step1.demoText1"
                                            )}
                                        </p>
                                        <p>
                                            {t(
                                                "wordDocumentVariables.howItWorks.step1.demoText2"
                                            )}
                                        </p>
                                        <p>
                                            {t(
                                                "wordDocumentVariables.howItWorks.step1.demoText3"
                                            )}
                                        </p>
                                        <p>
                                            {t(
                                                "wordDocumentVariables.howItWorks.step1.demoText4"
                                            )}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="relative flex items-start mb-8">
                            <div className="flex items-center justify-center w-8 h-8 rounded-full bg-blue-500 text-white font-bold text-sm absolute">
                                2
                            </div>
                            <div className="ml-12">
                                <h3 className="text-xl font-medium mb-3">
                                    {t(
                                        "wordDocumentVariables.howItWorks.step2.title"
                                    )}
                                </h3>
                                <div className="bg-white  shadow-sm rounded-lg border p-4">
                                    <p>
                                        {t(
                                            "wordDocumentVariables.howItWorks.step2.description"
                                        )}
                                    </p>
                                    <div className="mt-3 flex justify-center">
                                        <img
                                            src="/static-files.png"
                                            alt="Uploading template screenshot"
                                            className="rounded-md shadow-sm w-full max-w-md"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="relative flex items-start">
                            <div className="flex items-center justify-center w-8 h-8 rounded-full bg-blue-500 text-white font-bold text-sm absolute">
                                3
                            </div>
                            <div className="ml-12">
                                <h3 className="text-xl font-medium mb-3">
                                    {t(
                                        "wordDocumentVariables.howItWorks.step3.title"
                                    )}
                                </h3>
                                <div className="bg-white  shadow-sm rounded-lg border p-4">
                                    <p className="mb-3">
                                        {t(
                                            "wordDocumentVariables.howItWorks.step3.description"
                                        )}
                                    </p>
                                    <ol className="list-decimal pl-6 space-y-2 mb-4">
                                        <li>
                                            {t(
                                                "wordDocumentVariables.howItWorks.step3.list1"
                                            )}
                                        </li>
                                        <li>
                                            {t(
                                                "wordDocumentVariables.howItWorks.step3.list2"
                                            )}
                                        </li>
                                    </ol>
                                    <div className="bg-gray-100  p-3 rounded-md">
                                        <p className="font-medium mb-1">
                                            {t(
                                                "wordDocumentVariables.howItWorks.step3.example"
                                            )}
                                        </p>
                                        <p className="whitespace-pre-line">
                                            {t(
                                                "wordDocumentVariables.howItWorks.step3.demoText"
                                            )}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="bg-blue-50  p-6 rounded-lg">
                    <h2 className="text-2xl font-semibold mb-4">
                        {t("wordDocumentVariables.tipsForSuccess.title")}
                    </h2>
                    <ul className="space-y-4">
                        <li className="flex">
                            <span className="text-green-600 mr-2">✓</span>
                            <span>
                                <strong>
                                    {t(
                                        "wordDocumentVariables.tipsForSuccess.tip1",
                                        {
                                            interpolation: {
                                                escapeValue: false,
                                            },
                                        }
                                    )}
                                </strong>
                            </span>
                        </li>
                        <li className="flex">
                            <span className="text-green-600 mr-2">✓</span>
                            <span>
                                <strong>
                                    {t(
                                        "wordDocumentVariables.tipsForSuccess.tip2"
                                    )}
                                </strong>
                            </span>
                        </li>
                        <li className="flex">
                            <span className="text-green-600 mr-2">✓</span>
                            <span>
                                <strong>
                                    {t(
                                        "wordDocumentVariables.tipsForSuccess.tip3"
                                    )}
                                </strong>
                            </span>
                        </li>
                        <li className="flex">
                            <span className="text-green-600 mr-2">✓</span>
                            <span>
                                <strong>
                                    {t(
                                        "wordDocumentVariables.tipsForSuccess.tip4"
                                    )}
                                </strong>
                            </span>
                        </li>
                    </ul>
                </section>

                <section>
                    <h2 className="text-2xl font-semibold mb-4">
                        {t("wordDocumentVariables.commonUses.title")}
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <div className="border p-4 rounded-lg">
                            <div className="flex items-center mb-2">
                                <span className="text-2xl mr-2">📝</span>
                                <h3 className="font-medium">
                                    {t(
                                        "wordDocumentVariables.commonUses.personalizedLetters.title"
                                    )}
                                </h3>
                            </div>
                            <p className="text-sm">
                                {t(
                                    "wordDocumentVariables.commonUses.personalizedLetters.description"
                                )}
                            </p>
                        </div>
                        <div className="border p-4 rounded-lg">
                            <div className="flex items-center mb-2">
                                <span className="text-2xl mr-2">📊</span>
                                <h3 className="font-medium">
                                    {t(
                                        "wordDocumentVariables.commonUses.businessDocuments.title"
                                    )}
                                </h3>
                            </div>
                            <p className="text-sm">
                                {t(
                                    "wordDocumentVariables.commonUses.businessDocuments.description"
                                )}
                            </p>
                        </div>
                        <div className="border p-4 rounded-lg">
                            <div className="flex items-center mb-2">
                                <span className="text-2xl mr-2">📋</span>
                                <h3 className="font-medium">
                                    {t(
                                        "wordDocumentVariables.commonUses.formLetters.title"
                                    )}
                                </h3>
                            </div>
                            <p className="text-sm">
                                {t(
                                    "wordDocumentVariables.commonUses.formLetters.description"
                                )}
                            </p>
                        </div>
                    </div>
                </section>

                <section className="bg-gray-50  p-6 rounded-lg">
                    <h2 className="text-2xl font-semibold mb-4">
                        {t("wordDocumentVariables.needHelp.title")}
                    </h2>
                    <p className="mb-4">
                        {t("wordDocumentVariables.needHelp.intro")}
                    </p>
                    <ol className="list-decimal pl-6 space-y-2">
                        <li>
                            {t("wordDocumentVariables.needHelp.step1", {
                                interpolation: { escapeValue: false },
                            })}
                        </li>
                        <li>{t("wordDocumentVariables.needHelp.step2")}</li>
                        <li>{t("wordDocumentVariables.needHelp.step3")}</li>
                        <li>{t("wordDocumentVariables.needHelp.step4")}</li>
                    </ol>
                </section>
            </div>
        </div>
    );
}

export default WordDocumentVariables;
